import Const from 'const';

export function shouldMaxSalaryBeUpdated(slate, sportConfig): boolean {
    const isMaxSalaryCapSet = 'max_salary_cap' in slate && slate.max_salary_cap !== null;

    if (!isMaxSalaryCapSet) {
        return false;
    }

    // @ts-ignore
    const maxSalary = sportConfig.getConfigProp('maxSalary', 0);

    return Number(slate.max_salary_cap) !== Number(maxSalary);
}

export function getSportsForModeAndSite(sportConfig, mode: string, site: string): string[] {
    const sports = sportConfig.getSportsBySite(site);

    return sports.filter((sport) => Const.MODE_SPORTS_MAP[mode].includes(sport));
}

export function getFirstSportForModeAndSite(sportConfig, mode: string, site: string): string {
    const [sport = ''] = getSportsForModeAndSite(sportConfig, mode, site);

    return sport;
}
